/**
 * Registry de componentes para slides type=custom.
 *
 * Espelha a ideia do componentRegistry das missões, mas para componentes
 * "livres" (sem máquina de interação/sync) referenciados por `componentId`
 * no manifest. Resolve componentId -> componente React; o SlideRouter
 * renderiza passando `slide.props` (se houver).
 *
 * Para registrar um componente novo: importe e adicione ao mapa abaixo.
 */

import type { ComponentType } from 'react'

import EnaOnaSeminario from '../components/custom/EnaOnaSeminario'

export const CUSTOM_COMPONENTS: Record<string, ComponentType<Record<string, unknown>>> = {
  'ena-ona-seminario': EnaOnaSeminario,
}

export function resolveCustom(
  componentId: string,
): ComponentType<Record<string, unknown>> | null {
  return CUSTOM_COMPONENTS[componentId] ?? null
}
